import { render } from "./VLogo.vue?vue&type=template&id=73d9538c&scoped=true"
import script from "./VLogo.vue?vue&type=script&lang=js"
export * from "./VLogo.vue?vue&type=script&lang=js"

import "./VLogo.vue?vue&type=style&index=0&id=73d9538c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d9538c"]])

export default __exports__